export enum CumulativeDataType {
    CumulativeUsageHours = 'Usage hours',
    CumulativeFuelUsed = 'Fuel used',
    CumulativeDistance = 'Odometer',
    CumulativePayloadTotal = 'Payload',
    CumulativeLoadCount = 'Load count'
}

export enum CumulativeData {
    CumulativeUsageHours = 'HIBOO.USAGE_HOURS',
    CumulativeFuelUsed = 'HIBOO.FUEL_USED',
    CumulativeDistance = 'HIBOO.ODOMETER',
    CumulativePayloadTotal = 'HIBOO.PAYLOAD',
    CumulativeLoadCount = 'HIBOO.LOAD_COUNT'
}

export interface CumulativeDataValue {
    type: CumulativeDataType;
    date: string;
    value: number;
    unit: string | null;


}

export class CumulativeUsage {
    cumulativeDatas: CumulativeDataValue[] = [];

    
}